
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/DatePicker/DatePicker.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./DatePicker.html');
        
        var script = require('./DatePicker.ts').default;
        module.exports = require('./DatePicker.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    